import { API_BASE } from '../config/api';

// This will be populated when the component mounts
let memberEmails = new Set();

export const loadMemberEmails = async () => {
  try {
    // Read the member list from the serverless api/ endpoint, which holds the
    // Upstash token server-side. The browser never sees a database credential.
    let text = '';
    const resp = await fetch(`${API_BASE}/api/members`);
    if (resp && resp.ok) {
      text = await resp.text();
    }

    memberEmails = new Set(String(text || '')
      .split(/\r?\n/)
      .map(email => email.trim().toLowerCase())
      .filter(Boolean));
  } catch (error) {
    console.error('Error loading member emails:', error);
  }
};

export const isMemberEmail = (email) => {
  return memberEmails.has(email.toLowerCase().trim());
};